module.exports = __webpack_public_path__ + "static/img/small-unknown.4f7bdf8d.svg";